module.exports = __webpack_public_path__ + "img/20.e58a840b.png";